import { useMutation, useQueryClient } from '@tanstack/react-query'
import { SheetType } from '../../Components/Sheets/lib/Enums/SheetType'
import { Sheet } from '../Types'

import * as PaymentAPI from '../API/PaymentAPI'

export const usePayment = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (sheet: { sheetType: SheetType; id: number }) =>
      PaymentAPI.payment(sheet.sheetType, sheet.id),
    onSuccess: (data, variables) => {
      const markAccepted = (sheet: Sheet) => ({
        ...sheet,
        has_accepted_payment: true,
      })

      queryClient.setQueryData(
        [variables.sheetType],
        (sheets: Sheet[] | undefined) =>
          sheets?.map((sheet) =>
            sheet.id === variables.id ? markAccepted(sheet) : sheet,
          ),
      )
      queryClient.setQueryData(
        [variables.sheetType, variables.id],
        (sheet: Sheet | undefined) => (sheet ? markAccepted(sheet) : sheet),
      )
    },
  })
}
